import React, {useState, useEffect} from 'react'
import {connect, } from 'react-redux'
import {Modal, Button, Box, Loading} from 'components'
import {getMembersNotInGroups, SearchableMemberList, nGetMembersOfGroup} from 'members'
import {getGroup} from 'groups/selectors'
import {addMembersToGroups} from 'groups'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import { addGuardian, addChild } from 'members/actions'
import { useReducer } from 'react'
import { update } from 'members/actions'
import {getActiveMemberId} from 'user/selectors'

const Flex = styled.div`
    display: flex;
    gap: 1em;
`


const AddRelationModal = ({
  rowMember,
  members,
  addGuardian,
  addChild,
  club,
  getMember,
  setSearchDisplay,
  fetchRelations,
  activeMemberId
}) => {
  const [t] = useTranslation()
  const [submitting, setSubmitting] = useState(false)
  const [rerender, setRerender] = useState(false);
  const [chosenMember, setChosenMember] = useState(null)
  useEffect(() => {
    if (rerender) {
      fetchRelations(rowMember.id)
      setRerender(false); // Reset rerender state to avoid unnecessary re-renders
    }
  }, [rerender]);
  
  members = members.filter(m => m.id !== activeMemberId);
  console.log('activeMemberId', activeMemberId)

  const addParentRelation =
    (members) =>{
      members.forEach(member => {
        if(member.id === chosenMember){
          const childUserId = rowMember.id
          const guardianUserId = member.id
          const clubId = club.id
          addGuardian( {  childUserId, guardianUserId, clubId })
          fetchRelations(rowMember.id)
          setRerender(true)
        }
      }
    )
  }

  const addChildRelation =
    (members) =>{
      members.forEach(member => {
        if(member.id === chosenMember){
          const childUserId = member.id
          const guardianUserId = rowMember.id
          const clubId = club.id
          addChild( {  childUserId, guardianUserId, clubId })
          fetchRelations(rowMember.id)
          setRerender(true)
        }
      }
    )
  }
  
  return (
    <SearchableMemberList members={members} chosenMember={setChosenMember}>
          {({}) => (
            <Flex>
                <Button
              small
              block
              primary
              disabled={submitting}
              onClick={()=>{
                addParentRelation(members)
                setSearchDisplay(false)
              }}
            >
              {submitting ? <Loading size={24} /> : t('Tilføj Forælder')}
            </Button>
            <Button
              small
              block
              primary
              disabled={submitting}
              onClick={()=>{
                addChildRelation(members)
                setSearchDisplay(false)
              }}
            >
              {submitting ? <Loading size={24} /> : t('Tilføj Barn')}
            </Button>
            </Flex>
            
          )}
        </SearchableMemberList>
  )
}

const enhancer = connect(
  (state, {group}) => ({
    group: getGroup(state, group),
    members: nGetMembersOfGroup(state, group),
    activeMemberId: getActiveMemberId(state)
  }),
  {
    addMembersToGroups: addMembersToGroups.requested,
    addGuardian: addGuardian.requested,
    addChild: addChild.requested,
    update: update.requested
  },
)

export default enhancer(AddRelationModal)
